import React from 'react'
import styles from './UIGameHelpButtons.module.scss'
import {UIGameHelpFullScreenButton} from './UIGameHelpFullScreenButton'
import {UIGameHelpInformationButton} from './UIGameHelpInformationButton'
import {UIGameHelpRulesButton} from './UIGameHelpRulesButton'
import {UIGameHelpUserSettingsButton} from './UIGameHelpUserSettingsButton'
import {UIGameHelpRulesButtonProvider} from './UIGameHelpRulesButton/UIGameHelpRulesButtonContext'
import {UIGameFullScreenProvider} from './UIGameHelpFullScreenButton/UIGameHelpFullScreenContext'
import {UIGameHelpLeaveGameProvider} from './UIGameHelpLeaveGameContext'
import {useUIGameSocketContext} from '../../contexts/UIGameSocketContext'
import {ModeSettingEnum} from '@colonist/types'
import {useUIGlobalContext} from '@colonist/ui'
import {useGameStore} from '../../store/GameStoreContext'
import {useRequestPause} from '../../hooks/usePause'
import clsx from 'clsx'

export const UIGameHelpUserSettingsButtonContainer = ({
    isRulesOptionVisible,
    initialCanResign,
    className,
}: {
    isRulesOptionVisible: boolean
    initialCanResign: boolean
    className?: string
}) => {
    const requestPause = useRequestPause()
    const {sendDisableKarma} = useUIGameSocketContext()
    const setIsOpenSettings = useGameStore((state) => state.gameUserSettings.setIsOpenSettings)
    const isMyColorSpectator = useGameStore((state) => state.isMyColorSpectator)

    return (
        <>
            <div className={styles.settingsButtonContainer}>
                <UIGameHelpRulesButtonProvider>
                    <UIGameHelpLeaveGameProvider initialCanResign={initialCanResign}>
                        <UIGameHelpUserSettingsButton
                            className={className}
                            isPlayerSpectator={isMyColorSpectator}
                            isRulesOptionVisible={isRulesOptionVisible}
                            onSettingsClick={() => setIsOpenSettings(true)}
                            onPauseGameClick={requestPause}
                            onDisableKarmaClick={sendDisableKarma}
                        />
                    </UIGameHelpLeaveGameProvider>
                </UIGameHelpRulesButtonProvider>
            </div>
        </>
    )
}

export const UIGameHelpButtons = ({initialCanResign, className}: {initialCanResign: boolean, className: string}) => {
    const {isUserOnDiscord, isUserOnMobile} = useUIGlobalContext()
    const modeSetting = useGameStore((state) => state.gameSettings.modeSetting)
    const isMechanicIslandExplorationActive = useGameStore((state) => state.gameState.mechanicIslandExplorationState) !== undefined
    const victoryPointsToWin = useGameStore((state) => state.gameSettings.victoryPointsToWin)
    const myColor = useGameStore((state) => state.myColor)
    const isOpenSettings = useGameStore((state) => state.gameUserSettings.isOpenSettings)
    const isBeginnerMode = modeSetting === ModeSettingEnum.BeginnerModeClassic4P

    if(isOpenSettings === true) return null

    return (
        <div className={clsx(styles.container, className)} style={{flexDirection: isUserOnMobile ? 'row' : 'column'}}>
            <UIGameHelpUserSettingsButtonContainer
                initialCanResign={initialCanResign}
                isRulesOptionVisible={false}
            />
            {!isBeginnerMode && <>
                <UIGameHelpRulesButtonProvider>
                    <UIGameHelpRulesButton />
                </UIGameHelpRulesButtonProvider>
                {isUserOnDiscord === false && <UIGameFullScreenProvider>
                    <UIGameHelpFullScreenButton />
                </UIGameFullScreenProvider>}
                <UIGameHelpInformationButton
                    gameMode={modeSetting}
                    isMechanicIslandExplorationActive={isMechanicIslandExplorationActive}
                    playerColor={myColor}
                    victoryPointsToWin={victoryPointsToWin}/>
            </>}
        </div>
    )
}
